const isReturningUserDataAvailable = require("../returningUser/isReturningUserDataAvailable");
const hideRoiCalculatorGateFormStep = require("./hideRoiCalculatorGateFormStep");
const showRoiCalculatorReturningUserStep = require("./showRoiCalculatorReturningUserStep");
const showRoiCalculatorGateFormStep = require("./showRoiCalculatorGateFormStep");
const hideRoiCalculatorReturningUserStep = require("./hideRoiCalculatorReturningUserStep");

/**
 * @return {void}
 */
module.exports = function initRoiCalculatorReturningUserVisibility() {
    if (isReturningUserDataAvailable()) {
        hideRoiCalculatorGateFormStep();
        showRoiCalculatorReturningUserStep();
    } else {
        showRoiCalculatorGateFormStep();
        hideRoiCalculatorReturningUserStep();
    }
}